import React, { useState } from 'react';

export default function Login({ onLogin }) {
  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (user === 'adpilot' && pass === 'DigiGrids2026!') {
      localStorage.setItem('adpilot_auth', 'true');
      onLogin();
    } else {
      setError('Invalid username or password.');
    }
  };

  return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', background:'#F8F8F6', fontFamily:'sans-serif' }}>
      <div style={{ width:360, padding:'48px 40px', background:'#FFFFFF', border:'0.5px solid #D8D8D4' }}>
        <div style={{ fontSize:10, fontWeight:700, letterSpacing:2, textTransform:'uppercase', color:'#C9A96E', marginBottom:8 }}>AdPilot</div>
        <div style={{ fontSize:22, fontWeight:700, color:'#111', marginBottom:32 }}>Sign in to continue</div>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom:16 }}>
            <label style={{ fontSize:9, letterSpacing:1.5, textTransform:'uppercase', color:'#AAA', display:'block', marginBottom:5 }}>Username</label>
            <input type="text" value={user} onChange={e => setUser(e.target.value)} style={{ width:'100%', border:'none', borderBottom:'0.5px solid #D8D8D4', padding:'9px 0', fontSize:13, color:'#111', background:'transparent', outline:'none' }} autoFocus />
          </div>
          <div style={{ marginBottom:24 }}>
            <label style={{ fontSize:9, letterSpacing:1.5, textTransform:'uppercase', color:'#AAA', display:'block', marginBottom:5 }}>Password</label>
            <input type="password" value={pass} onChange={e => setPass(e.target.value)} style={{ width:'100%', border:'none', borderBottom:'0.5px solid #D8D8D4', padding:'9px 0', fontSize:13, color:'#111', background:'transparent', outline:'none' }} />
          </div>
          {error && <div style={{ fontSize:11, color:'#E53935', marginBottom:16 }}>{error}</div>}
          <button type="submit" style={{ width:'100%', padding:14, background:'#C9A96E', color:'#111', fontSize:11, fontWeight:700, letterSpacing:1, textTransform:'uppercase', border:'none', cursor:'pointer' }}>Sign In</button>
        </form>
      </div>
    </div>
  );
}
